<template>
    <section class="columns is-gapless is-multiline is-fullheight bng-game">
        <jackpots-bar v-if="jackpots && jackpots.length" />
        <div class="column game-container">
            <div
                class="game"
                :class="{
                    'game-portrait-orientation': provider === 'aviatrix' || gameId === 'aviator_spribe' || gameId === 'aviator'
                }"
            >
                <div class="game-content" ref="gameFrame">
                    <template v-if="!showAuthPrompt">
                        <game-redpipe v-if="provider === 'redpipe'" :gameId="gameId" :backUrl="backUrl" />
                        <game-flg v-if="provider === 'flg'" :gameId="gameId" :backUrl="backUrl" />
                        <game-mascot v-if="provider === 'mascot'" :gameId="gameId" :backUrl="backUrl" />
                        <game-aviatrix v-if="provider === 'aviatrix'" />
                        <game-softgamings v-if="provider === 'softgamings'" :gameId="gameId" />
                        <game-galaxsys v-if="provider === 'galaxsys'" :gameId="gameId" />
                        <game-smartsoft v-if="provider === 'smartsoft'" :gameId="gameId" />
                        <game-vegas v-if="provider === 'vegas'" :gameId="gameId" />
                        <game-boldplay v-if="provider === 'boldplay'" :gameId="gameId" />
                        <game-doubleChanceLotto v-if="provider === 'doublechancelotto'" :gameId="gameId" />
                        <game-betconstruct v-if="provider === 'betconstruct'" :gameId="gameId" />
                        <game-baas v-if="provider === 'baas'" :gameId="gameId" />
                    </template>
                    <div v-else class="game-responsive responsive_9x16">
                        <div class="message-info">{{ $t('components.pages.game.please-login') }}</div>
                    </div>

                    <div class="game-controls">
                        <a class="btn-fullscreen" @click="toggleFullScreen()">
                            <span class="fas fa-expand-arrows-alt"></span>
                            {{ 'components.pages.slot-game.fullscreen' | translate }}
                        </a>
                        <a class="btn-close" @click="goBack()">
                            <span class="far fa-times-circle"></span>
                            {{ 'components.pages.video-game.close' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import utils from '../../../../../../_common/utils';
import JackpotsBar from '../../../common/jackpots/jackpots-bar/jackpots-bar.vue';
import GameAviatrix from './game-aviatrix.vue';
import GameFlg from './game-flg.vue';
import GameMascot from './game-mascot.vue';
import GameRedpipe from './game-redpipe.vue';
import GameSoftgamings from './game-softgamings.vue';
import GameGalaxsys from './game-galaxsys.vue';
import GameSmartsoft from './game-smartsoft.vue';
import GameVegas from './game-vegas.vue';
import GameBoldplay from './game-boldplay.vue';
import GameDoubleChanceLotto from './game-doublechancelotto.vue';
import GameBetconstruct from './game-betconstruct.vue';
import GameBaas from './game-baas.vue';

const gameProvidersNotSupportDemo = ['flg'];
const gamesNotSupportDemo = [
    // example
    // {
    //     provider: 'redpipe',
    //     gameId: 'aviator'
    // }
];

export default {
    name: 'game',
    components: {
        JackpotsBar,
        GameAviatrix,
        GameFlg,
        GameMascot,
        GameRedpipe,
        GameSoftgamings,
        GameGalaxsys,
        GameSmartsoft,
        GameVegas,
        GameBoldplay,
        GameDoubleChanceLotto,
        GameBetconstruct,
        GameBaas
    },
    computed: {
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        player() {
            return Vue.state.player.get();
        },
        jackpots() {
            return (this.player && this.player.balance && this.player.activeJackpots) || [];
        },
        provider() {
            return this.$route.params.provider;
        },
        gameId() {
            return this.$route.params.game;
        },
        game() {
            return Vue.state.games.getById(this.provider, this.gameId);
        },
        backUrl() {
            const path = this.$router.resolver.gameBack().fullPath;
            return `${window.location.protocol}//${window.location.host}${path}`;
        },
        isSupportDemo() {
            if (gameProvidersNotSupportDemo.includes(this.provider)) return false;

            const foundNotSupportGame = gamesNotSupportDemo.find(item => item.gameId === this.gameId && item.provider === this.provider);
            return !foundNotSupportGame;
        },
        showAuthPrompt() {
            if (this.isLoggedIn) return false;

            return !this.isSupportDemo;
        }
    },
    methods: {
        toggleFullScreen() {
            utils.openFullscreen(this.$refs.gameFrame);
        },
        goBack() {
            Vue.router.push(this.$router.resolver.gameBack());
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/game/game.vue